/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_List_Description1Inputs */

const en_coinvestments_list_description1 = /** @type {(inputs: Coinvestments_List_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View and manage your co-investment opportunities`)
};

/**
* | output |
* | --- |
* | "View and manage your co-investment opportunities" |
*
* @param {Coinvestments_List_Description1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_list_description1 = /** @type {((inputs?: Coinvestments_List_Description1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_List_Description1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_list_description1(inputs)
});
export { coinvestments_list_description1 as "coInvestments_list_description" }